export const RECIPIENTS = 'recipients';
